import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { TaskStatus, TaskPriority } from "../../../__generated__/globalTypes";
import { useCreateTask } from "../hooks";
import { TaskForm } from "../components";
import { useMe } from "../../users/hooks/useMe";

export const CreateTask: React.FC = () => {
  const { data: meData } = useMe();
  const { form, submit, loading } = useCreateTask({
    defaultValues: {
      status: TaskStatus.Todo,
      priority: TaskPriority.Medium,
      description: "",
      userId: meData?.me?.id,
    },
    onCompleted: () => {
      toast.success("La tâche a été créée avec succès");
    },
  });

  useEffect(() => {
    if (meData?.me?.id) {
      form.setValue("userId", meData.me.id);
    }
  }, [meData]);

  return (
    <>
      <Header
        title="Tâche"
        subtitle="Créer une nouvelle tâche"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/tasks`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouvelle tâche" />
          <TaskForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
